export default "__VITE_ASSET__DT_RIiXc__"